import React from 'react';
import ReactDOM from 'react-dom';
import './ResetView.scss';

export default function ResetViewButton(props) {
    const { onReset } = props;

    return ReactDOM.createPortal(
            <div
                tabIndex="-1"
                data-tabindex={1}
                className="btn resetView threeButtons"
                id="resetView"
            onClick={() => onReset()}                
            role="button"
                aria-label="Reset View"
            >
                <span alt="Reset view"> </span>
        </div>,
        document.getElementById('resetViewDesk') // Updated target container
    );
}
